import { render, staticRenderFns } from "./PendingCard.vue?vue&type=template&id=79788203"
import script from "./PendingCard.vue?vue&type=script&lang=ts"
export * from "./PendingCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports